<template>
  <div class="row">
    <div class="col-lg-8">
      <h2 class="inline">Asset Relocation Approval</h2>
    </div>

    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <h4 slot="header" class="card-title">List of Asset</h4>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <base-input label="rows visible">
              <el-select
                class="select-info mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </base-input>
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
              ></el-input>
            </base-input>
          </div>
          <el-table
            :data="queriedData"
            @selection-change="handleSelectionChange"
            :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
            <el-table-column
              min-width="130"
              sortable
              align="center"
              label="Picture"
            >
              <div class="photos" slot-scope="{ row }">
                <input
                  @click="row.modalCol = true"
                  type="image"
                  :src="row.image"
                  width="100%"
                  height="100%"
                  style="border-radius: 5px"
                />
                <modal :show.sync="row.modalCol" centered>
                  <div class="text-center">
                    <img :src="row.image" />
                  </div>
                </modal>
              </div>
            </el-table-column>
            <el-table-column type="selection" width="55"></el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
    <div class="col-lg-12 text-right">
      <base-button type="primary" :disabled="dis" @click="handleEdit()"
        >Approve</base-button
      >
    </div>
  </div>
</template>
<script>
import { BasePagination, Modal } from "src/components";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import Fuse from "fuse.js";
import swal from "sweetalert2";

export default {
  components: {
    BasePagination,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },

  data() {
    return {
      modals: {
        modal0: false,
      },
      selects: {
        simple_site: "",
        site: [
          { value: "All", label: "All" },
          { value: "Klang Valley", label: "Klang Valley" },
          { value: "Klang Valley", label: "KLIA" },
        ],
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["assetNo", "prevSite", "requestSite", "statusName"],
      tableColumns: [
        {
          prop: "assetNo",
          label: "Asset No",
          minWidth: 150,
        },
        {
          prop: "assetDesc",
          label: "Asset Description",
          minWidth: 150,
        },
        // {
        //   prop: "image",
        //   label: "Image",
        //   minWidth: 150
        // },
        {
          prop: "lastMaintenanceDate",
          label: "Last Maintenance Date",
          minWidth: 150,
        },
        {
          prop: "prevSite",
          label: "Previous Site",
          minWidth: 150,
        },
        {
          prop: "requestSite",
          label: "Request Site",
          minWidth: 150,
        },
        {
          prop: "statusName",
          label: "Status Name",
          minWidth: 150,
        },
      ],
      tableData: [
        {
          assetNo: "DHES 1",
          assetCondition: "Operational",
          site: "Site A",
          location: "HQ",
        },
        {
          assetNo: "DHES 245",
          assetCondition: "Breakdown",
          site: "Site B",
          location: "HQ",
        },
        {
          assetNo: "DHES 908",
          assetCondition: "Operational",
          site: "Site C",
          location: "HQ",
        },
        {
          assetNo: "DHES 789",
          assetCondition: "Breakdown",
          site: "Site D",
          location: "HQ",
        },
        {
          assetNo: "DHES 708",
          assetCondition: "Operational",
          site: "Site E",
          location: "HQ",
        },
        {
          assetNo: "DHES 213",
          assetCondition: "Operational",
          site: "Site F",
          location: "HQ",
        },
      ],
      searchedData: [],
      fuseSearch: null,
      dis: true,
      site: [],
    };
  },
  created() {
    this.getRelocationApproval();
    this.getSite();
  },
  methods: {
    getSite() {
      this.site = [];
      this.$http.get(":9996/api/v1/manage/site").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].SiteName,
              value: response[i].SiteID,
            };
            this.site.push(obj);
          }
        }
      });
    },
    handleEdit() {
      console.log(this.multipleSelection[0].assetMoveId);
      // assign id
      let movementid = this.multipleSelection[0].assetMoveId;

      // get site id
      let siteid = 0;
      for (var i = 0; i < this.site.length; i++) {
        if (this.multipleSelection[0].requestSite == this.site[i].label) {
          siteid = this.site[i].value;
        }
      }

      let payload = {
        AssetMovementID: this.multipleSelection[0].assetMoveId,
        AssetNo: this.multipleSelection[0].assetNo,
        SiteID: siteid,
      };
      console.log(movementid);
      console.log(payload);

      this.$http
        .put(":9996/api/v1/move/approve/" + movementid, payload)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: "transaction completed!",
              message: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              cancelButtonClass: "btn btn-danger btn-fill",
              confirmButtonText: "Okay!",
              buttonsStyling: false,
            });
            this.getRelocationApproval();
          }
        });
    },
    getRelocationApproval() {
      this.tableData = [];
      this.$http.get(":9996/api/v1/move/request").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let img = `https://afes.vectolabs.com:9996/images/${response[i].ImagePath}`;
            if (response[i].ImagePath == "") {
              img = require("@/assets/img/No_Image_Available.png");
            }
            let obj = {
              assetNo: response[i].AssetNo,
              assetDesc: response[i].AssetDesc,
              assetMoveId: response[i].AssetMovementID,
              image: img,
              lastMaintenanceDate: response[i].LastMaintenanceDate,
              prevSite: response[i].PrevSite,
              requestSite: response[i].RequestSite,
              statusName: response[i].StatusName,
              modalCol: false,
            };
            this.tableData.push(obj);
          }
        }
      });
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    handleSelectionChange(val) {
      if (val.length > 1) {
        swal({
          title: "only single select allowed!",
          type: "error",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
        this.dis = true;
      } else {
        console.log(val);
        this.multipleSelection = val;
        console.log(this.multipleSelection);
        this.dis = false;
      }
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["assetNo", "prevSite", "requestSite", "statusName", "assetDesc"],
      threshold: 0.3,
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
  margin-bottom: 1%;
}
hr {
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
.photos {
  width: 120px;
  height: 120px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
